import { getEnterpriseValueFormula, getEquityValueFormula } from 'common/formulas/math.js/ENTERPRISE_AND_EQUITY_VALUE';
import { AfterCellChanged } from 'common/types/scalarSpreadsheet';
import {
  EXIT_ENTERPRISE_VALUE_ALIAS,
  EXIT_EQUITY_ALIAS,
  LESS_DEBT_ALIAS,
  PLUS_CASH_ALIAS
} from 'pages/Waterfall/SpreadsheetConfig/constants';

export const inputSheetAfterCellsChanged: AfterCellChanged = (
  initialChanges,
  cells) => {
  if (initialChanges.length === 0) {
    throw new Error('No changes detected');
  }
  const change = initialChanges[0];
  const { cell, value } = change;

  const changes = [...initialChanges];
  //   if the cell.alias is the equity value, then we will update the cell with an alias of enterprise value
  //     with a formula that will calculate the enterprise value and vice versa
  if (cell.alias === EXIT_EQUITY_ALIAS) {
    const cashCell = Object.values(cells).find(c => c.alias === PLUS_CASH_ALIAS);
    const debtCell = Object.values(cells).find(c => c.alias === LESS_DEBT_ALIAS);
    const enterpriseValueCell = Object.values(cells).find(c => c.alias === EXIT_ENTERPRISE_VALUE_ALIAS);
    if (enterpriseValueCell && cashCell && debtCell) {
      const expr = getEnterpriseValueFormula(cell.key, cashCell.key, debtCell.key);
      changes.push({ cell: enterpriseValueCell, value: `=${ expr}` });
    }
  }
  if (cell.alias === EXIT_ENTERPRISE_VALUE_ALIAS) {
    const cashCell = Object.values(cells).find(c => c.alias === PLUS_CASH_ALIAS);
    const debtCell = Object.values(cells).find(c => c.alias === LESS_DEBT_ALIAS);
    const equityValueCell = Object.values(cells).find(c => c.alias === EXIT_EQUITY_ALIAS);
    if (equityValueCell && cashCell && debtCell) {
      const expr = getEquityValueFormula(cell.key, cashCell.key, debtCell.key);
      changes.push({ cell: equityValueCell, value: `=${ expr}` });
    }
  }
  return changes
}